import { ReactComponent as CheckBox } from "./checkbox-icon.svg";

const CheckBoxIcon: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = (props) => <CheckBox {...props} />;

export default CheckBoxIcon;
